<template>
    <div class="question-view__wrapper">
        <div class="question-view__middle">
            <h3>Minua kiinnostaa</h3>
        </div>
        <div class="question-view__content" :key="answer">
            <div class="question-view__question" v-if="question.question !== null">
                <h4>{{ question.question }}</h4>
            </div>
            <div v-if="question.type === 'tf'" class="question-view__buttton-group">
                <button
                    @click="submitAnswer"
                    class="btn btn--black"
                    value="Kyllä"
                >
                    Kyllä
                </button>
                <button
                    @click="submitAnswer"
                    class="btn btn--black"
                    value="Ei"
                >
                    Ei
                </button>
            </div>
            <div v-if="question.type === 'mc'" class="question-view__button-group">
                <button
                    v-for="(mcanswer, index) in question.answers"
                    :key="index"
                    @click="submitAnswer"
                    class="btn btn--black"
                    :value="mcanswer"
                >
                    {{mcanswer}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            answer: '',
        }
    },
    props: ['question'],
    // props: ['question', 'question-number', 'question-length'],
    methods: {
        submitAnswer: function() {
            this.answer = event.target.value;
            this.$emit('answer', {answer: this.answer});
            this.answer = null;
        }
    }
}
</script>

